<template>
    <div>
        <!-- Modal Item Estoque -->
        <div class="modal fade" id="vinculoEstoqueItemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Vincular Item vs Cobrança</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!lista || !lista.length" titulo="Nenhum item encontrado para vincular." icon="fa-solid fa-link" /> 

                        <div v-else>
                            <div class="mb-2">
                                {{ lista.length }} item(ns) encontrado(s)
                            </div>
                        
                            <div class="table-responsive-md">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Descrição</th>
                                            <th>Código</th>
                                            <th>Cobrança</th>
                                            <th>Tipo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(ei, iex) in lista" :key="iex">
                                            <td>#{{ ei.id_estoque_item }}</td>
                                            <td>{{ ei.st_estoque_item }}</td>
                                            <td>{{ ei.st_id_externo }}</td>
                                            <td>
                                                <span v-if="ei.material_vinc">{{ ei.material_vinc.st_material }}
                                                    <span class="badge badge-secondary">#{{ ei.material_vinc.id_material }}</span>
                                                </span>
                                                <span v-else-if="ei.medicamento_vinc">{{ ei.medicamento_vinc.st_material }}
                                                    <span class="badge badge-secondary">#{{ ei.medicamento_vinc.id_material }}</span>
                                                </span>
                                            </td>
                                            <td>
                                                {{ ei.material_vinc ? 'Material' : ( ei.medicamento_vinc ? 'Medicamento' : '' ) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar" v-if="lista && lista.length">Vincular</az-submit>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            lista: [], 
        }
    },

    components: { 
        AzEmptyState, 
        AzSubmit, 
    }, 

    methods: { 
        abrir() { 
            this.lista = [];
            $('#vinculoEstoqueItemModal').modal('show');

            this.$util.load(this, { 
                service: 'estoque_items',
                func: 'lista_vincular_cobranca', 
                loadTo: res => { 
                    this.lista = res;
                }
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'estoque_items',
                func: 'vincular_cobranca', 
                dados: { 
                    lista: this.lista, 
                },
                toast: true,
                modal: 'vinculoEstoqueItemModal',
            });
        }
    }
}
</script>
